module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Angle-up-2050da6c1accb0798df9e9a099a6c37e.svg";